import { motion } from "framer-motion";

const TESTIMONIALS = [
  {
    name: "Elainne Rose Froilan",
    quote:
      "That's amazing! So that's how we teach that word. A lot of my students get confused about it too.",
    offset: false,
  },
  {
    name: "Donna Jane Conejero Rasco",
    quote: "Excellent technique!",
    offset: true,
  },
  {
    name: "Titser Hanny",
    quote: "that made it easy",
    offset: false,
  },
  {
    name: "Shwn Nzrn Pntr",
    quote:
      'Yes! I agree with the teaching methodology. We share this knowledge the same way to these students who demonstrated difficulty sounding the "ay" sound. Nice job, teach!',
    offset: true,
  },
];

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="relative w-full px-4 py-20 sm:px-8 sm:py-28"
    >
      <div className="mx-auto max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="mx-auto max-w-2xl text-center"
        >
          <span className="font-mono-accent text-xs font-semibold uppercase tracking-[0.25em] text-sky-600">
            Real Feedback
          </span>
          <h2 className="font-display mt-4 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            What teachers and learners are saying
          </h2>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {TESTIMONIALS.map((item, i) => (
            <motion.div
              key={item.name}
              data-testid={`testimonial-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className={`flex flex-col items-center justify-center rounded-3xl border border-slate-200/70 bg-white p-8 text-center shadow-[0_25px_55px_-20px_rgba(15,23,42,0.18)] transition-transform duration-300 hover:-translate-y-1.5 sm:p-10 ${
                item.offset ? "sm:mt-8" : ""
              }`}
            >
              <p className="font-display text-xl font-bold leading-snug text-slate-900 sm:text-2xl">
                “{item.quote}”
              </p>
              <span className="font-mono-accent mt-5 text-xs font-semibold uppercase tracking-[0.2em] text-sky-600">
                {item.name}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
